module.exports = __webpack_public_path__ + "static/img/暂无收藏.9360324.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/暂无收藏.jpg
// module id = k9y1
// module chunks = 1